import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from './storage/local-storage.service';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class TwclidService {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private localStorage = inject(LocalStorageService);

  private xAdsData: BehaviorSubject<{
    twclid: string | null;
    productId: string | null;
  }> = new BehaviorSubject(null);

  public xAdsData$ = this.xAdsData.asObservable();
  constructor() {
    this.captureTwclid();
  }

  private captureTwclid() {
    this.route.queryParamMap.subscribe((params) => {
      const twclid = params.get('twclid');
      if (twclid) {
        const url = this.router.url;
        const segments = url.split('?')[0].split('/');
        const data = {
          twclid: twclid,
          productId: segments.length > 2 ? segments[2] : null
        };
        this.xAdsData.next(data);
        // optional: remove twclid from URL after capture
        this.router.navigate([], {
          queryParams: { ...params.keys.filter((k) => k !== 'twclid') },
          replaceUrl: true
        });
      }
      // else {
      // this.twclid = this.localStorage.getItem('twclid');
      // }
    });
  }
}
